import React, {Component} from 'react'

import style from './resultTimer.module.scss'

const mins = localStorage.getItem('time') ? Math.trunc(30 - ((Date.now() - Number(localStorage.getItem('time'))) / 60000)) : 29

class ResultTimer extends Component {
   state = {
      minutes: mins > 0 ? mins : 0,
      seconds: mins >= 0 ? 59 : 26,
   }

   minutesTimer = () => {
      const localStorageTime = Number(localStorage.getItem('time'))
      const halfHour = 30 - ((Date.now() - localStorageTime) / 60000)
      this.setState({minutes: halfHour > 0 ? Math.trunc(halfHour) : 0})

   }

   secondsTimer() {
      if (localStorage.getItem('time')) {
         let secT = setInterval(() => {
            this.setState(prevstate => ({
               seconds: prevstate.seconds - 1,
            }))
            clearInterval(secT)
         }, 1000)
         if (this.state.seconds === -1) {
            clearInterval(secT)
            this.setState({seconds: 59})
            if (this.state.minutes > 0) {
               this.minutesTimer()
            }
         }
      }
   }

   componentDidMount() {
      this.setState({minutes: mins > 0 ? mins : 0})
   }

   componentDidUpdate() {
      if (mins >= 0) {
         this.secondsTimer()
      }
   }

   render() {
      const {minutes, seconds} = this.state

      return (
         <div className={style.resultTimer__block}>
            <ul className={style.resultTimer__list}>
               <li className={style.resultTimer__item}>
                  <span className={style.resultTimer__num}>00</span>
                  <span className={style.resultTimer__text}>Days</span>
               </li>
               <li className={style.resultTimer__item}>
                  <span className={style.resultTimer__num}>00</span>
                  <span className={style.resultTimer__text}>Hours</span>
               </li>
               <li className={style.resultTimer__item}>
                  <span className={style.resultTimer__num}>{minutes > 9 ? minutes : `0${minutes}`}</span>
                  <span className={style.resultTimer__text}>Minutes</span>
               </li>
               <li className={style.resultTimer__item}>
                  <span className={style.resultTimer__num}>{seconds > 9 ? seconds : `0${seconds}`}</span>
                  <span className={style.resultTimer__text}>Seconds</span>
               </li>
            </ul>
         </div>
      )
   }
}

export default ResultTimer